import { render, staticRenderFns } from "./basket-24.vue?vue&type=template&id=a23b9c1e&scoped=true"
import script from "./basket-24.vue?vue&type=script&lang=js"
export * from "./basket-24.vue?vue&type=script&lang=js"
import style0 from "./basket-24.vue?vue&type=style&index=0&id=a23b9c1e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23b9c1e",
  null
  
)

export default component.exports